module.exports = __webpack_public_path__ + "img/gallery_3.9bed78db.jpg";